export const COLOR_PALETTE = ['#ff0000', '#00ff00', '#00ffff', '#ff00ff', '#ffff00'];
